import RadioGroup from "components/RadioGroup";
import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const JobPurposeWrapper = styled.div`
    // padding-top: 5rem;
    width: 100%;
    grid-area: main;
    margin: 0 14px;
    border-radius: 24px;
    position: relative;
    height: 100%;
    background-color: ${theme.colors.white};
    padding: 16px 14px;
    /* overflow-y: scroll; */

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 6.5rem;
    }
`;

export const PurposeTitle = styled(Text)`
    margin-top: 5rem;
`;

export const PurposeOptions = styled(RadioGroup)`
    grid-row-gap: 1rem;
`;

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 2rem;
`;

export const NoDataText = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;
